export interface Quest {
  id: string;
  emoji: string;
  label: string;
  hint: string;
  /** The page it opens; visiting it ticks the quest (except `first-lead`). */
  path?: string;
}

/**
 * The first-day checklist for whoever set the workspace up. A quest ticks
 * when its page is opened (Add Lead: when the form opens; the tour: when it
 * is finished), so it nudges people into every corner without nagging.
 */
export const QUESTS: Quest[] = [
  { id: "tour", emoji: "🧭", label: "Take the 2-minute tour", hint: "Learn your way around" },
  { id: "first-lead", emoji: "➕", label: "Add your first lead", hint: "A name and a phone number is enough", path: "/leads" },
  { id: "teammate", emoji: "👯", label: "Invite a teammate", hint: "Sales is a team sport", path: "/user-management" },
  { id: "source", emoji: "🧲", label: "Connect a lead source", hint: "Website, Facebook, WhatsApp…", path: "/source-management" },
  { id: "stages", emoji: "🛣️", label: "Make the stages yours", hint: "Rename, add, reorder", path: "/stage-management" },
  { id: "automation", emoji: "🤖", label: "Hire your robot intern", hint: "Set up your first automation", path: "/automation" },
  { id: "reports", emoji: "📊", label: "Peek at your reports", hint: "See what's working", path: "/report" },
];
